import React, { Component } from "react";
import PropTypes from "prop-types";
import graphql from "graphql";
import styled from "styled-components";
import { Box, Text, Container, Flex, Heading } from "rebass";
import Helmet from "react-helmet";

import logo from "../img/logo.png";
import Stripe from "../components/Stripe/Stripe";
import StripeCheckout from "../components/Stripe/StripeCheckout";
import FacebookButton from "../components//ui/FacebookButton";
import Button from "../components//ui/Button";
import PlanCard from "../components/Pricing/PlanCard";

const { Fragment } = React;

class PageTemplate extends Component {
  state = {
    loggedIn: false,
    step: 0
  };

  componentDidMount() {
    this.context.mixpanel.track("demo_subscribe_step", { step: 0 });
  }

  handleLogin = () => {
    this.setState({
      loggedIn: true,
      step: 1
    });

    this.context.mixpanel.track("demo_subscribe_logged_in");
  };

  changeStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    });

    this.context.mixpanel.track("demo_subscribe_step", { step: step + 1 });
  };

  close = () => {
    this.context.mixpanel.track("demo_subscribe_closed");

    window.location.href = "https://www.messenger.com/closeWindow/";
  };

  render() {
    const { siteMetadata } = this.props;
    const { loggedIn, step } = this.state;

    return (
      <Fragment>
        <Helmet htmlAttributes={{ class: "internal-page" }} />

        <LogoBox mt={[4]} mb={[3]}>
          <img src={logo} alt="Pipeline" height="27" />
        </LogoBox>

        <Container mb={[5]}>
          {!loggedIn && <Auth handleLogin={this.handleLogin} />}

          {loggedIn &&
            step === 1 && (
              <Package
                siteMetadata={siteMetadata}
                changeStep={this.changeStep}
              />
            )}

          {loggedIn &&
            step === 2 && (
              <Stripe
                render={
                  <Fragment>
                    <StripeCheckout />
                  </Fragment>
                }
              />
            )}
        </Container>
      </Fragment>
    );
  }
}

PageTemplate.contextTypes = { mixpanel: PropTypes.object.isRequired };

const Auth = ({ handleLogin }) => (
  <Fragment>
    <Text align="center" mb={[4]}>
      Let&apos;s get started by setting up your account&hellip;
    </Text>
    <Text align="center">
      <StyledFacebookButton mb={[2, 2, 3, 4]} onClick={handleLogin}>
        LOGIN WITH FACEBOOK
      </StyledFacebookButton>
    </Text>
  </Fragment>
);

const Package = ({ siteMetadata, changeStep }) => (
  <PlanFlex wrap mx="auto">
    {/* <Box align="center" mb={[3]}>
      <ul>
        <li>Automated social media marketing</li>
        <li>Detailed conversion analytics</li>
        <li>Flexible pay-as-you-grow pricing</li>
      </ul>
    </Box> */}

    <PlanCard
      w={[1, 1, "auto"]}
      my={[2]}
      flex={["auto"]}
      title="Starter Package"
      price="49.00"
      currency="usd"
      period="per month"
      subscriberCount={250}
      subscribeButtonClick={changeStep}
      siteMetadata={siteMetadata}
      subscribeButtonLabel="Proceed to Payment"
    />
  </PlanFlex>
);

type Props = {
  data: {}
};

export default ({ data }: Props) => {
  const { siteMetadata } = data.site;

  return <PageTemplate siteMetadata={siteMetadata} />;
};

export const subscribePageQuery = graphql`
  query subscribePage($path: String!) {
    site {
      siteMetadata {
        appUrl
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
      }
    }
  }
`;

// Styled Components
const LogoBox = styled(Box)`
  height: 54px;
  line-height: 54px;
  text-align: center;
`;

const StyledFacebookButton = styled(FacebookButton)`
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  height: 56px;
  padding-top: 15px;
  position: relative;
  width: auto;
  z-index: 1;
`;

const PlanFlex = styled(Flex)`
  max-width: 380px;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/templates/subscribe-page.js